import React, { useEffect, lazy, Suspense } from 'react';
import ContactPage from './components/ContactPage/ContactPage';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { saveUtmParams } from './utils/utmManager';
import { checkAndUpdateReferrer } from './utils/referralManager';
import { getOrCreateTrackingId } from './utils/trackingManager';
import { initPostHog } from './utils/posthogManager';

// Lazy load - só carrega se acessar /qualificacao
const TypebotQualificacao = lazy(() => import('./components/TypebotQualificacao'));
// Formulário antigo de 8 etapas, mantido em /form-antigo para comparação
const RegistrationScreen = lazy(() => import('./components/RegistrationScreen'));

const App = () => {
  useEffect(() => {
    getOrCreateTrackingId();
    initPostHog();

    const captureUtms = () => {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('utm_source') || urlParams.has('utm_medium') ||
          urlParams.has('utm_campaign') || urlParams.has('utm_id') ||
          urlParams.has('utm_term') || urlParams.has('utm_content')) {
        saveUtmParams();
      }
    };

    const captureReferrer = () => {
      checkAndUpdateReferrer();
    };

    captureUtms();
    captureReferrer();

    const handleUrlChange = () => {
      captureUtms();
      captureReferrer();
    };

    window.addEventListener('popstate', handleUrlChange);

    return () => {
      window.removeEventListener('popstate', handleUrlChange);
    };
  }, []);

  return (
    <Router>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<ContactPage />} />
          <Route path="/qualificacao" element={<TypebotQualificacao />} />
          <Route path="/formulario" element={<ContactPage />} />
          <Route path="/form-antigo" element={<RegistrationScreen />} />
          <Route path="*" element={<ContactPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;
